export var logger = {
  // eslint-disable-next-line no-console
  warn: function warn(msg, scope) {
    return console.warn("[".concat(scope, "]: ").concat(msg));
  }
};